import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';

import { Text, BlackText } from '../../components/common/Text';
import {
  PrimaryButton,
  InvertedSubscriptionButton,
} from '../../components/common/Buttons';
import { setBotChatInfo } from '../../actions';
import { fetchProfile, fetchAssistantProfile } from '../../services';
import StyledTappable from '../../components/common/StyledTappable';
import LoadingComponent from '../../components/common/LoadingComponent';
import { logEvent } from '../../utils/logEvent';
import FooterButton from '../../components/common/FooterButton';
import Header from '../../components/common/Header';

import megaPhone from '../../images/megaphone.svg';
import education from '../../images/education.svg';
import addressIcon from '../../images/consultations/new-flow/profile/doctor-center.svg';
import hospitalIcon from '../../images/consultations/new-flow/profile/profile-hospital.svg';
import consultationFeeIcon from '../../images/consultation_fee_icon.svg';
import doctorPlaceholder from '../../images/consultations/doctor-placeholder.svg';
import user from '../../images/common/user-icon.svg';
import GreenPhone from '../../images/consultations/Green-phone.svg';
import WebsiteImage from '../../images/consultations/Blue-website.svg';
import PhoneBook from '../../images/consultations/PhoneBook.svg';

const MapsContainer = styled(StyledTappable)`
  margin-top: 12px;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  width: 100%;
`;
const MapsImage = styled.img`
  width: 100%;
  height: 83px;
  border-radius: 5px;
`;

const SecondaryContainer = styled.div`
  display: flex;
  padding: 14px;
`;

const FeesIcon = styled.img`
  width: 1.125rem;
  margin-right: 6px;
`;

const ContainerWithBorder = styled.div`
  background: #ffffff;
  border: 1px solid #e3e3e3;
  width: calc(100%-40px);
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin: 20px 20px 0px 20px;
`;
const Row = styled.div`
  display: flex;
  margin-left: 20px;
  margin-right: 16px;
  flex-direction: row;
  margin-top: 16px;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
`;

const DoctorImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  src: url(${(props) => props.src});
`;
const DoctorName = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.25px;
  line-height: 24px;
  color: #0f0b28;
`;

const Profession = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
  color: #585969;
  margin-right: 16px;
  word-break: initial;
`;

const FooterContainer = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0 -1.7px 5px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  width: ${({ hasBookForFree }) => (hasBookForFree ? '50%' : '100%')};
  margin: ${({ hasBookForFree }) =>
    hasBookForFree ? '20px 0px 20px 20px' : '20px 20px 20px 20px'};
  padding-left: 0;
  padding-right: 0;
  background: var(--primary-button);
  border-radius: 12px;
  margin: 20px;
`;

const SecondaryTitleText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  margin-left: 8px;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const BodyText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.5px;
  color: #0f0b28;
  margin: 8px 4px 2px 2px;
`;

const TreatmentButtonContainer = styled(StyledTappable)`
  margin: 0.375rem;
  margin-top: 0;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 0.5rem 0.875rem;
  border-radius: 0.375rem;
  background-image: linear-gradient(to left, #8852cc, #6d33b6);
`;

const TreatmentButtonIcon = styled.img`
  max-width: 2.625rem;
  margin-right: 0.625rem;
`;
const TreatmentTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const TreatmentTitle = styled(Text)`
  font-size: 1rem;
  color: white;
  margin-bottom: 0.375rem;
`;
const ArrowRight = styled(FaChevronRight)`
  color: white;
`;
const TreatmentSubtitle = styled(BlackText)`
  color: white;
  font-size: 0.875rem;
`;
const StyledSubscriptionButton = styled(InvertedSubscriptionButton)`
  flex: 1;
  margin: 20px 20px 20px 20px;
  padding-left: 0;
  padding-right: 0;
`;
const CallClinicContainer = styled.a`
  border: 1px solid #1eb865;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 8px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;

const GoToWebsiteContainer = styled.a`
  border: 2px solid #cfc8ff66;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 8px;
  //styleName: Body/Paragraph_Medium;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #585969;
`;

const DoctorProfile = (props) => {
  const authToken = useSelector((state) => state.user.authToken);
  const [requestLoading, setRequestLoading] = useState(true);
  const [doctorProfile, setDoctorProfile] = useState({});
  const [bookingInfo, setBookingInfo] = useState({
    offline: {
      opdLabel: '',
      bookingLabel: '',
    },
    online: {
      opdLabel: '',
      bookingLabel: '',
    },
  });
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const getAssistantProfile = () => {
    const { doctorId } = this.props;

    fetchAssistantProfile(doctorId, authToken)
      .then((res) => {
        setDoctorProfile(res.result[0]);
        setBotChatInfo(res.bookingInfo);
        setBookingInfo(res.bookingInfo);
      })
      .catch((err) => {
        console.error('Error in fetching doctor profile', err);
      })
      .finally(() => {
        setRequestLoading(false);
      });
  };

  const getProfile = () => {
    const { doctorId, currentLat, currentLong } = props;
    let lat = currentLat !== -1 ? currentLat : undefined;
    let lng = currentLong !== -1 ? currentLong : undefined;
    fetchProfile(doctorId, lat, lng, authToken)
      .then((res) => {
        setDoctorProfile(res.result[0]);
        setBotChatInfo(res.bookingInfo);
        setBookingInfo(res.bookingInfo);
      })
      .catch((err) => {
        console.error('Error in fetching doctor profile', err);
      })
      .finally(() => {
        setRequestLoading(false);
      });
  };

  useEffect(() => {
    if (props.card === 'pre-book-appointment') {
      logEvent('Funnel Self Book Doctor Info Opened');
    } else {
      logEvent('Offline Appointments Doctor Profile Screen');
    }

    if (props?.assistantDoctor) {
      getAssistantProfile();
    } else {
      getProfile();
    }
  }, []);

  const openMaps = () => {
    document.querySelector('#doctor-profile-map-link').click();
  };

  const { bookDoctor, onShowOpd, currentList, bookingLabel, opdLabel } = props;
  const bookingLabelText =
    bookingLabel == null || bookingLabel === undefined
      ? bookingInfo[currentList].bookingLabel
      : bookingLabel;
  const opdLabelText =
    opdLabel == null || opdLabel === undefined
      ? bookingInfo[currentList].opdLabel
      : opdLabel;

  if (!doctorProfile) {
    return (
      <div style={{ height: '100svh', background: '#ffffff' }}>
        <LoadingComponent />
      </div>
    );
  }

  if (requestLoading) {
    return (
      <div style={{ height: '100svh', background: '#ffffff' }}>
        <LoadingComponent />
      </div>
    );
  }

  const {
    address,
    profileImg,
    doctorName,
    vertical,
    experience,
    orgName,
    summary,
    qualification,
    specializations,
    baseFee,
    finalFee,
    knownLanguages,
    latitude,
    longitude,
    centerContactNumber,
    centerWebsiteUrl,
    distance,
    doctorId,
    verticalId,
  } = doctorProfile;

  return (
    <div
      className="flex flex-col h-full items-stretch bg-white doctorProfileModal"
      onClick={(e) => e.stopPropagation()}
    >
      <Header title="Profile" onTap={props.closeProfile} />
      {requestLoading ? (
        <div style={{ height: '100svh', background: '#ffffff' }}>
          <LoadingComponent />
        </div>
      ) : (
        <>
          <div className="w-full h-full pb-100px  overflow-y-scroll">
            <ContainerWithBorder
              style={{
                paddingBottom: '20px',
              }}
            >
              <Row className="border-b border-solid border-txtsecondary-shades4 pb-20px">
                <DoctorImage
                  src={profileImg ? profileImg : doctorPlaceholder}
                  width={48}
                  height={48}
                />
                <Column>
                  <DoctorName>{doctorName}</DoctorName>
                  <Profession>{vertical}</Profession>
                  <Profession>{experience}</Profession>
                </Column>
              </Row>
              <Row
                className="border-b border-solid border-txtsecondary-shades4 pb-14px"
                style={{ marginTop: '12px !important' }}
              >
                <div className="flex-center flex flex-row justify-between">
                  <div className="flex flex-row items-center">
                    <FeesIcon src={hospitalIcon} />
                    <div className="text-body-s font-regular text-txtlight ml-5 mr-8px">
                      {orgName}
                    </div>
                  </div>
                  {/* <div
                className="text-body-l text-txtlight font-semibold text-right mr-16px"
                style={{ width: '120px' }}
              >
                {distance}
              </div> */}
                </div>
              </Row>

              {qualification?.length > 0 && (
                <Row
                  className="border-b border-solid border-txtsecondary-shades4 pb-14px"
                  style={{ marginTop: '12px !important' }}
                >
                  <div className="flex-center flex flex-row justify-between">
                    <div className="flex flex-row items-center">
                      <FeesIcon src={education} />
                      <div className="text-body-s font-regular text-txtlight ml-5 mr-8px">
                        {qualification}
                      </div>
                    </div>
                  </div>
                </Row>
              )}

              {knownLanguages && (
                <Row
                  className="border-solid border-txtsecondary-shades4 "
                  style={{ marginTop: '12px !important' }}
                >
                  <div className="flex-center flex flex-row justify-between">
                    <div className="flex flex-row items-center">
                      <FeesIcon src={megaPhone} />
                      <div className="text-body-s font-regular text-txtlight ml-5 mr-8px">
                        {knownLanguages}
                      </div>
                    </div>
                  </div>
                </Row>
              )}

              {address && (
                <Row>
                  <div className="flex-center">
                    <FeesIcon
                      src={addressIcon}
                      alt="org"
                      className="self-start"
                    />
                    <div className="text-body-s text-txtlight ml-5">
                      {address}
                    </div>
                  </div>
                </Row>
              )}
              {latitude &&
                longitude &&
                latitude.trim() !== '' &&
                longitude.trim() !== '' && (
                  <Row>
                    <MapsContainer onTap={openMaps}>
                      <MapsImage
                        src={`${process.env.REACT_APP_MMI_BASE_URL}/still_image?&center=${latitude},${longitude}&zoom=15&markers=${latitude},${longitude}&size=300x83`}
                      />
                      <a
                        href={`https://maps.mapmyindia.com/navigation?places=current_location;${latitude},${longitude},${orgName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        id="doctor-profile-map-link"
                        style={{ display: 'none' }}
                      >
                        {''}
                      </a>
                    </MapsContainer>
                  </Row>
                )}
            </ContainerWithBorder>
            {props.card === 'pre-book-appointment' &&
              (centerContactNumber !== null || centerWebsiteUrl !== null) && (
                <ContainerWithBorder>
                  <SecondaryContainer className="flex-col">
                    <div className="flex items-center flex-1">
                      <img src={PhoneBook} alt="" />
                      <SecondaryTitleText>
                        Centre Contact Details
                      </SecondaryTitleText>
                    </div>
                    <div
                      className="flex items-center gap-20px"
                      style={{
                        margin: '8px 4px 2px 2px',
                      }}
                    >
                      {centerContactNumber !== null && (
                        <CallClinicContainer
                          href={`tel: ${centerContactNumber}`}
                          onClick={() => logEvent('Funnel Self Book Doctor Info Call Clinic CTA Clicked')}
                        >
                          <img src={GreenPhone} alt="Phone" />
                          <div>Call Clinic</div>
                        </CallClinicContainer>
                      )}
                      {centerWebsiteUrl !== null && (
                        <GoToWebsiteContainer
                          href={centerWebsiteUrl}
                          target="_blank"
                          onClick={() => logEvent('Funnel Self Book Doctor Info Website CTA Clicked')}
                        >
                          <img src={WebsiteImage} alt="Website" />
                          <div>Go to Website</div>
                        </GoToWebsiteContainer>
                      )}
                    </div>
                  </SecondaryContainer>
                </ContainerWithBorder>
              )}

            <ContainerWithBorder>
              <SecondaryContainer>
                <div className="flex justify-between flex-1 ">
                  <div className="flex items-center flex-1">
                    <img src={consultationFeeIcon} alt="" />
                    <SecondaryTitleText>You Pay</SecondaryTitleText>
                  </div>
                  <div className="flex flex-1 items-center justify-end">
                    {baseFee !== finalFee && (
                      <div
                        className="txt-grey-500-12 mr-5"
                        style={{ textDecoration: 'line-through' }}
                      >
                        ₹{baseFee}
                      </div>
                    )}
                    <SecondaryTitleText>₹{finalFee}</SecondaryTitleText>
                  </div>
                </div>
              </SecondaryContainer>
            </ContainerWithBorder>
            {summary.length > 0 && (
              <ContainerWithBorder>
                <SecondaryContainer>
                  <div className="flex flex-col p-2px">
                    <div className="flex flex-row items-center">
                      <img src={user} alt="" />
                      <SecondaryTitleText>About</SecondaryTitleText>
                    </div>
                    <BodyText style={{ marginRight: '2px' }}>
                      {isExpanded ? summary : `${summary.slice(0, 100)}...`}
                      {summary.length > 100 && (
                        <span
                          onClick={handleToggle}
                          style={{
                            color: 'blue',
                            cursor: 'pointer',
                            marginLeft: '5px',
                          }}
                        >
                          {isExpanded ? 'Read Less' : 'Read More'}
                        </span>
                      )}
                    </BodyText>
                  </div>
                </SecondaryContainer>
              </ContainerWithBorder>
            )}

            {specializations.length > 0 && (
              <ContainerWithBorder>
                <SecondaryContainer>
                  <div className="flex flex-col p-2px">
                    <div className="flex flex-row items-center">
                      <img src={user} alt="" />
                      <SecondaryTitleText>Specialization</SecondaryTitleText>
                    </div>
                    <BodyText style={{ marginRight: '2px' }}>
                      {specializations}
                    </BodyText>
                  </div>
                </SecondaryContainer>
              </ContainerWithBorder>
            )}

            {qualification.length > 0 && (
              <ContainerWithBorder style={{ marginBottom: '50px' }}>
                <SecondaryContainer>
                  <div className="flex flex-col">
                    <div className="flex flex-row">
                      <img src={education} alt="" />
                      <SecondaryTitleText>Qualification</SecondaryTitleText>
                    </div>
                    <BodyText>{vertical}</BodyText>
                  </div>
                </SecondaryContainer>
              </ContainerWithBorder>
            )}
          </div>
          {props.footer && (
            <>
              {bookingLabelText.trim() !== '' && (
                <FooterButton
                  buttonText={bookingLabelText}
                  onClick={() => {
                    if (props.card === 'pre-book-appointment') {
                      logEvent('Funnel Self Book Doctor Info Pay CTA Clicked');
                      props.onTapOfInPreBookStepsModal(
                        'doctorProfile',
                        doctorProfile
                      );
                    } else {
                      bookDoctor(doctorProfile, currentList);
                    }
                  }}
                ></FooterButton>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DoctorProfile;
